var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isElementResizing)?_c('ResizableBlock',{staticClass:"resizable-creator",style:(Object.assign({}, _vm.resizableBlockBounding))}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }